import type { ModuleID, VersionString, ViewID } from "@bestowinc/tinkertoy-core";

import { isAbortError, resolveErrorCode, resolveFailureError } from "./normalize";
import { reportTinkertoyFailure } from "./recorder";
import { FAILURE_EVENT_TAGS } from "./types";

export async function withActionFailureReporting<T>(
  args: {
    actionScope: "module" | "view_interaction";
    actionName: string;
    viewId: ViewID;
    viewVersion: VersionString;
    moduleId?: ModuleID;
    moduleVersion?: VersionString;
  },
  run: () => Promise<T>,
): Promise<T> {
  try {
    return await run();
  } catch (error) {
    if (!isAbortError(error)) {
      const failureError = resolveFailureError(error, "Action request failed.");
      const tag =
        args.actionScope === "module"
          ? FAILURE_EVENT_TAGS.moduleAction
          : FAILURE_EVENT_TAGS.viewInteraction;
      reportTinkertoyFailure({
        tag,
        errorCode: resolveErrorCode(error),
        message: failureError.message,
        error: failureError,
        actionScope: args.actionScope,
        actionName: args.actionName,
        viewId: args.viewId,
        viewVersion: args.viewVersion,
        moduleId: args.moduleId,
        moduleVersion: args.moduleVersion,
      });
    }
    throw error;
  }
}
